import {useApi} from "../Api";
import {PagedResponse} from "../types/pagination";
import {buildQueryParams} from "../../utils";
import {
    FormSearchOWAncillaryModel,
    OWAncillaryEntityRequest,
    OWAncillaryEntityResponse,
    OwAncillaryPrePopulatedFields
} from "../types/owAncillary";

export const useOWAncillaryRepository = () => {
    const {GET, POST, PUT, DELETE} = useApi();

    const PATH = "/pricing/ow-ancillary";

    function getOWAncillary(owAncillaryId: number): Promise<OWAncillaryEntityResponse> {
        return GET(`${PATH}?id=${owAncillaryId}`);
    }

    function getOWAncillaries(): Promise<OWAncillaryEntityResponse[]> {
        return GET(`${PATH}/list`);
    }

    function getOwAncillaryPrePopulatedFields(): Promise<OwAncillaryPrePopulatedFields> {
        return GET(`${PATH}/get-prepopulated`);
    }

    function getOWAncillariesPaged(filters: FormSearchOWAncillaryModel): Promise<PagedResponse<OWAncillaryEntityResponse>> {
        const query = "?";

        const queryParams = buildQueryParams(filters);

        return GET(`${PATH}/filter${queryParams ? query + queryParams : ""}`);
    }

    function putOWAncillary(owAncillary: OWAncillaryEntityResponse): Promise<OWAncillaryEntityResponse> {
        return PUT(`${PATH}`, owAncillary);
    }

    function postOWAncillary(owAncillary: OWAncillaryEntityRequest): Promise<OWAncillaryEntityResponse> {
        return POST(`${PATH}`, owAncillary);
    }

    function deleteOWAncillary(owAncillaryId: number): Promise<string> {
        return DELETE(`${PATH}?id=${owAncillaryId}`);
    }

    function terminateOWAncillary(owAncillaryId: number): Promise<OWAncillaryEntityResponse> {
        return GET(`${PATH}/terminate?id=${owAncillaryId}`);
    }

    return {
        getOWAncillary,
        getOWAncillaries,
        getOWAncillariesPaged,
        putOWAncillary,
        postOWAncillary,
        deleteOWAncillary,
        getOwAncillaryPrePopulatedFields,
        terminateOWAncillary
    };
};